
<div class="min-h-screen bg-[#F5F5F5]">
	<div class="flex flex-col justify-between min-h-screen">
		<div>
			<ng-container *ngTemplateOutlet="header"></ng-container>
		</div>
		<div class="grow mx-[20px]">
			<ng-container *ngTemplateOutlet="body"></ng-container>
		</div>
		<div class="mx-[20px] pb-[40px]">
			<ng-container *ngTemplateOutlet="footer"></ng-container>
		</div>
	</div>
</div>


<ng-template #header>
	<app-mobile-timeline-template-v2
		(goBack)="goBack()"
		[previous]="previousTitle"
		[version]="CustomTimelineVersion.version_8"
		[currentStep]="currentStep"
		[description]="description"
		[title]="title"
		[total]="totalStep">
	</app-mobile-timeline-template-v2>
</ng-template>
<ng-template #body>
	<div class="flex flex-col bg-white gap-[24px] rounded-[16px] pt-[16px] pb-[24px] px-[16px] justify-center">
		<div class="w-full flex flex-col gap-[16px]">
			<div class="relative">
			<div class="form-floating">
					<input type="password" (ngModelChange)="handleOldPassword($event)" [(ngModel)]="oldPassword" class="form-control" id="oldPassword" placeholder="Enter {{oldPasswordPlaceHolder}}">
					<label for="oldPassword">{{oldPasswordPlaceHolder}}</label>
			</div>
			<div (click)="setVisibleOldPassword(!isVisibleOldPwd)"
					 class="flex w-[16px] justify-end z-10 cursor-pointer vertically-centralized mr-[16px]">
					<ng-container *ngIf="isVisibleOldPwd else secretPassword">
						<ng-container *ngTemplateOutlet="visiblePassword"></ng-container>
					</ng-container>
				</div>
			</div>
			<ng-container *ngIf="useNewPasswordHint && !validOldPassword && oldPassword?.length">
				<div class="flex flex-col">
					<div class="text-[#808080] leading-normal text-[10px] font-semibold">
						Your password should contain:
					</div>
					<div *ngFor="let newPwHint of oldPasswordHints" class="flex flex-col gap-[8px]">
						<div class="flex gap-[8px] items-center">
							<div>
								<ng-container *ngIf="newPwHint.isPassed else hintEmpty">
									<ng-container *ngTemplateOutlet="hintPassed"></ng-container>
								</ng-container>
							</div>
							<div class="leading-[16.28px] text-black font-normal text-[11px]">
								{{newPwHint.hint}}
							</div>
						</div>
					</div>
				</div>
			</ng-container>
		</div>
		<div class="w-full flex flex-col gap-[16px]">
			<div class="relative">
			<div class="form-floating">
				<input type="password" (ngModelChange)="handleNewPassword($event)"  [(ngModel)]="newPassword" class="form-control" id="newPassword" placeholder="Enter {{newPasswordPlaceHolder}}">
				<label for="newPassword">{{newPasswordPlaceHolder}}</label>
			</div>
			<div (click)="setVisibleNewPassword(!isVisibleNewPwd)"
					 class="flex w-[16px] justify-end z-10 cursor-pointer vertically-centralized mr-[16px]">
					<ng-container *ngIf="isVisibleNewPwd else secretPassword">
						<ng-container *ngTemplateOutlet="visiblePassword"></ng-container>
					</ng-container>
				</div>
			</div>
			<ng-container *ngIf="useNewPasswordHint && !validNewPassword && newPassword?.length">
				<div class="flex flex-col">
					<div class="text-[#808080] leading-normal text-[10px] font-semibold">
						Your password should contain:
					</div>
					<div *ngFor="let newPwHint of newPasswordHints" class="flex flex-col gap-[8px]">
						<div class="flex gap-[8px] items-center">
							<div>
								<ng-container *ngIf="newPwHint.isPassed else hintEmpty">
									<ng-container *ngTemplateOutlet="hintPassed"></ng-container>
								</ng-container>
							</div>
							<div class="leading-[16.28px] text-black font-normal text-[11px]">
								{{newPwHint.hint}}
							</div>
						</div>
					</div>
				</div>
			</ng-container>
		</div>
	</div>
</ng-template>
<ng-template #footer>
	<div class="kamona-button-session pt-[24px]">
		<app-kamona-custom-button
			[isSubmitting]="submitting"
			[isDisabled]="!(validOldPassword && validNewPassword)"
			(submitForm)="submit()"
			[isBlock]="true" [text]="btnText">
		</app-kamona-custom-button>
	</div>
</ng-template>
<ng-template #hintEmpty>
	<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="6.72827" cy="6.69922" r="5.5" stroke="#B2B2B2"/>
	</svg>
</ng-template>
<ng-template #hintPassed>
	<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="6.72827" cy="6.69922" r="6" fill="#1EB12D"/>
		<path d="M3.52515 7.07102C3.7807 6.82307 4.19469 6.82268 4.45056 7.07016L5.5357 8.11959C5.61933 8.20056 5.75471 8.20048 5.83835 8.11936L9.54574 4.51974C9.80288 4.27016 10.2199 4.27086 10.4761 4.52129C10.7309 4.77057 10.7302 5.17298 10.4743 5.42132L6.39542 9.38151C6.00417 9.76129 5.37004 9.76129 4.97879 9.38151L3.52515 7.97026C3.26945 7.72193 3.26945 7.31936 3.52515 7.07102Z" fill="white"/>
	</svg>
</ng-template>

<ng-template #visiblePassword>
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M8.00009 10C9.10466 10 10.0001 9.10457 10.0001 8C10.0001 6.89543 9.10466 6 8.00009 6C6.89552 6 6.00009 6.89543 6.00009 8C6.00009 9.10457 6.89552 10 8.00009 10Z" fill="#9BA6B9"/>
		<path d="M15.3389 7.45625C14.512 6.1775 13.4392 5.09125 12.2367 4.31469C10.9064 3.45469 9.43763 3 7.98951 3C6.66076 3 5.3542 3.37969 4.10607 4.12844C2.83326 4.89188 1.68013 6.00719 0.678572 7.44312C0.565505 7.60541 0.503235 7.79764 0.499673 7.9954C0.496112 8.19315 0.551421 8.3875 0.658572 8.55375C1.48388 9.84531 2.54607 10.9331 3.72982 11.6991C5.06263 12.5625 6.49701 13 7.98951 13C9.4492 13 10.9211 12.5491 12.2458 11.6962C13.4476 10.9222 14.5183 9.83187 15.342 8.5425C15.4455 8.38012 15.5002 8.19146 15.4996 7.99892C15.4991 7.80638 15.4433 7.61804 15.3389 7.45625ZM8.00013 11C7.40679 11 6.82677 10.8241 6.33342 10.4944C5.84008 10.1648 5.45556 9.69623 5.2285 9.14805C5.00143 8.59987 4.94202 7.99667 5.05778 7.41473C5.17353 6.83279 5.45926 6.29824 5.87881 5.87868C6.29837 5.45912 6.83292 5.1734 7.41486 5.05764C7.99681 4.94189 8.60001 5.0013 9.14818 5.22836C9.69636 5.45542 10.1649 5.83994 10.4945 6.33329C10.8242 6.82664 11.0001 7.40666 11.0001 8C10.9992 8.79537 10.6829 9.5579 10.1205 10.1203C9.55804 10.6827 8.7955 10.9991 8.00013 11Z" fill="#9BA6B9"/>
	</svg>
</ng-template>
<ng-template #secretPassword>
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M13.5 13.9997C13.4344 13.9998 13.3693 13.9869 13.3087 13.9618C13.248 13.9366 13.1929 13.8997 13.1466 13.8532L2.14659 2.85317C2.05678 2.75864 2.00745 2.63277 2.00912 2.50239C2.01079 2.37201 2.06333 2.24744 2.15553 2.15524C2.24773 2.06303 2.3723 2.0105 2.50268 2.00883C2.63306 2.00716 2.75894 2.05649 2.85347 2.1463L13.8535 13.1463C13.9234 13.2162 13.9709 13.3053 13.9902 13.4023C14.0095 13.4992 13.9996 13.5997 13.9618 13.691C13.9239 13.7824 13.8599 13.8605 13.7777 13.9154C13.6955 13.9703 13.5989 13.9997 13.5 13.9997Z" fill="#999999"/>
		<path d="M7.74993 9.87006L6.1315 8.25162C6.12222 8.24242 6.1103 8.23636 6.09741 8.23429C6.08451 8.23222 6.07129 8.23424 6.0596 8.24007C6.04791 8.24589 6.03834 8.25523 6.03224 8.26678C6.02613 8.27833 6.0238 8.29149 6.02556 8.30443C6.0909 8.72432 6.28805 9.11255 6.58853 9.41303C6.889 9.71351 7.27723 9.91066 7.69712 9.976C7.71006 9.97776 7.72323 9.97543 7.73477 9.96932C7.74632 9.96321 7.75566 9.95365 7.76149 9.94196C7.76731 9.93027 7.76933 9.91705 7.76726 9.90415C7.76519 9.89126 7.75913 9.87934 7.74993 9.87006Z" fill="#999999"/>
		<path d="M8.24996 6.12984L9.8709 7.75015C9.88016 7.75948 9.89211 7.76565 9.90507 7.7678C9.91803 7.76994 9.93133 7.76795 9.9431 7.76211C9.95486 7.75626 9.96448 7.74685 9.97059 7.73523C9.97671 7.7236 9.979 7.71035 9.97715 7.69734C9.91198 7.27689 9.71468 6.88809 9.41383 6.58723C9.11297 6.28637 8.72417 6.08908 8.30371 6.0239C8.29069 6.02189 8.27737 6.02405 8.26565 6.03007C8.25393 6.03608 8.24441 6.04565 8.23845 6.05739C8.23249 6.06914 8.23039 6.08247 8.23246 6.09549C8.23453 6.1085 8.24065 6.12052 8.24996 6.12984Z" fill="#999999"/>
		<path d="M15.3438 8.54247C15.4472 8.38009 15.5019 8.19143 15.5014 7.99889C15.5008 7.80635 15.445 7.61801 15.3406 7.45622C14.5138 6.17748 13.441 5.09123 12.2385 4.31467C10.9063 3.45467 9.43752 2.99998 7.99002 2.99998C7.22693 3.00103 6.46902 3.12545 5.74565 3.36842C5.7254 3.37515 5.70721 3.38695 5.69282 3.40271C5.67843 3.41846 5.66831 3.43763 5.66342 3.4584C5.65853 3.47917 5.65904 3.50084 5.6649 3.52136C5.67076 3.54187 5.68178 3.56055 5.6969 3.5756L7.17315 5.05185C7.18848 5.06722 7.20755 5.07832 7.22849 5.08407C7.24942 5.08983 7.27149 5.09003 7.29252 5.08466C7.79291 4.96272 8.31627 4.97166 8.81221 5.11061C9.30815 5.24957 9.75996 5.51386 10.1241 5.87804C10.4883 6.24223 10.7526 6.69404 10.8916 7.18997C11.0305 7.68591 11.0395 8.20927 10.9175 8.70966C10.9122 8.73065 10.9124 8.75266 10.9182 8.77353C10.9239 8.7944 10.935 8.81342 10.9503 8.82872L13.0738 10.9537C13.0959 10.9759 13.1254 10.9889 13.1567 10.9903C13.1879 10.9917 13.2186 10.9813 13.2425 10.9612C14.0599 10.2645 14.7682 9.44921 15.3438 8.54247Z" fill="#999999"/>
		<path d="M8 11.0001C7.54586 11.0001 7.09764 10.897 6.68913 10.6986C6.28063 10.5002 5.9225 10.2116 5.64175 9.85467C5.361 9.49771 5.16496 9.08166 5.06841 8.6379C4.97186 8.19414 4.97732 7.73425 5.08437 7.29291C5.08968 7.27192 5.08945 7.24991 5.0837 7.22904C5.07795 7.20817 5.06687 7.18915 5.05156 7.17385L2.96281 5.08416C2.94066 5.06198 2.91099 5.04894 2.87968 5.04761C2.84837 5.04628 2.8177 5.05676 2.79375 5.07697C2.03156 5.72728 1.325 6.51853 0.679061 7.44322C0.565994 7.6055 0.503723 7.79774 0.500162 7.99549C0.496601 8.19325 0.55191 8.3876 0.659061 8.55385C1.48437 9.84541 2.54625 10.9332 3.73031 11.6992C5.06437 12.5626 6.4975 13.0001 7.99 13.0001C8.76079 12.998 9.52658 12.8763 10.26 12.6392C10.2804 12.6326 10.2988 12.621 10.3134 12.6053C10.3281 12.5896 10.3384 12.5704 10.3434 12.5495C10.3485 12.5287 10.3481 12.5069 10.3423 12.4863C10.3365 12.4656 10.3255 12.4468 10.3103 12.4317L8.82687 10.9485C8.81157 10.9332 8.79255 10.9221 8.77168 10.9164C8.75081 10.9106 8.7288 10.9104 8.70781 10.9157C8.47606 10.9719 8.23845 11.0002 8 11.0001Z" fill="#999999"/>
	</svg>
</ng-template>
